import Blue from "~/core";
import TabsManual from "~/components/_tabsManual";

new Blue({
  name: 'Agenda',
  selector: ".agenda",
  setup(agenda) {
    const tablists = agenda.querySelectorAll('[role=tablist]')
    const tabs = agenda.querySelectorAll('[role=tab]')
    const tabpanels = agenda.querySelectorAll('.agenda__tabpanel')
    const toggleAllBtn = `<button class="agenda__tab js-agenda-all" id="tab-all" type="button" role="tab" aria-selected="false" tabindex="-1"><span class="agenda__focus">All</span></button>`
    tablists.forEach(e => {
      new TabsManual(e)
      // Adding All button
      // very hacky but we want to leave the wai-aria tab system alone
      e.insertAdjacentHTML('afterbegin', toggleAllBtn)
      // button we just added
      let allButton = e.children[0]
      allButton.addEventListener('click', function () {
        if (this.getAttribute('aria-selected') === 'false') {
          this.setAttribute('aria-selected', 'true')
          this.removeAttribute('tabindex')
          tabpanels.forEach(e => {
            e.classList.remove('is-hidden')
          });
          tabs.forEach(e => {
              e.setAttribute('aria-selected', 'false')
              e.tabIndex = -1
          })
        } else {
          this.setAttribute('aria-selected', 'false')
          this.tabIndex = -1
          this.nextElementSibling.click()
          this.nextElementSibling.focus()
        }
        
      })
      // defaulting to all
      allButton.click()
      tabs.forEach(e => {
        e.addEventListener('click', function() {
          if(allButton.getAttribute('aria-selected') === 'true') {
            allButton.setAttribute('aria-selected', 'false')
            allButton.tabIndex = -1
          }
          
        })
      });
    })
  }
});